<template>
<div :class="{'warning-icon':(!isMyUserAdmin)}" />
<div :class="{'row':true , 'disabled-overlay':(!isMyUserAdmin)}">
  <div>
  <h3>Services Configuration</h3>
    <!--<p>Services configuration changes are only applied after a succesful restart of the Enfyo device, make sure to read the device documentation before making changes as the following options can dramatically change behavior of the the device in runtime</p>-->
    <DxButton
      text="Save changes"
      type="success"
      style="float: right;"
      @click="saveChanges"
    />
    <DxButton
      text="Set Defaults"
      type="normal"
      style="float: right;"
      @click="setDefaults"
    />
  </div>

  <DxForm :form-data="configData" label-location="left" :min-col-width="350">
    <DxGroupItem caption="MQTT Server" css-class="third-group" :col-count="2" >
      <DxSimpleItem 
        data-field="mqttServer.serverEnabled" 
        editor-type="dxCheckBox" 
        help-text="Enables internal MQTT broker"
        :label="{ text: 'MQTT Server Enabled'}" />
      <DxSimpleItem
        data-field="mqttServer.publisherEnabled"
        editor-type="dxCheckBox"
        help-text="Enables publication of signals status in MQTT broker, used by webapp realtime monitor (default: true)"
        :label="{ text: 'IoT Publisher Enabled'}"
      />
    </DxGroupItem>
    <DxGroupItem caption="Signal Storage Task" css-class="third-group" :col-count="2" >
      <DxSimpleItem 
        data-field="scheduler.signalStorage.enabled" 
        editor-type="dxCheckBox"
        help-text="Enables datastorage globally"
        :label="{ text: 'Enable Global Storage'}" />
      <DxSimpleItem 
        data-field="scheduler.signalStorage.secondsToSample" 
        editor-type="dxNumberBox"
        :editor-options="{ max: 3600*24, min: 1, hint: 'Sampling period for storage daemon in seconds (default: 1)' }"
        :label="{ text: 'Global Sampling Period (s)'}" />
      <DxSimpleItem 
        data-field="scheduler.signalStorage.secondsToFlush" 
        editor-type="dxNumberBox"
        :editor-options="{ max: 3600*24, min: 1, hint: 'Database flush period in seconds, must be superior to sampling (default: 20)' }" 
        :label="{ text: 'DB Flush Period (s)' }"/>
    </DxGroupItem>
    <DxGroupItem caption="Local IoT Updater" css-class="third-group" :col-count="2" >
      <DxSimpleItem
        data-field="scheduler.iotUpdater.secondsLocalTick"
        editor-type="dxNumberBox"
        :editor-options="{ max: 3600, min: 0.5, hint: 'Period for local IoT signal publisher daemon in seconds, used by webapp realtime monitor (default: 2)' }" 
        :label="{ text: 'Local IoT Tick period (s)'}" />
      <DxSimpleItem
        data-field="scheduler.iotUpdater.secondsCloudTick"
        editor-type="dxNumberBox"
        :editor-options="{ max: 3600, min: 0.5, hint: 'Period for cloud IoT signal publisher daemon in seconds, (default: 10)'}" 
        :label="{ text: 'Cloud IoT Tick period (s)'}" />
    </DxGroupItem>
  </DxForm>
</div>
</template>

<script>
import { reactive } from 'vue'
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
} from 'devextreme-vue/form';
import DxButton from 'devextreme-vue/button';
import RawDataService from '../services/RawDataServiceTemplate';
import notify from 'devextreme/ui/notify';
import { useStore } from 'vuex';
const confObj = {
    "device": {
        "deviceType": "enfyoDefault"
    },
    "mqttServer": {
        "serverEnabled": false,
        "publisherEnabled": false
    },
    "scheduler": {
        "signalStorage": {
            "enabled": true,
            "secondsToSample": 0,
            "secondsToFlush": 0
        },
        "iotUpdater": {
            "secondsLocalTick": 0,
            "secondsCloudTick": 0
        }
    }
}

export default {
  components: {
    DxForm,
    DxGroupItem,
    DxSimpleItem,
    DxButton,
  },
  setup() {
    // Validate permissions
    const store = useStore()
    const DEF_AUTHCODES = { web:1, admon:100, iot:120 };
    const isMyUserAdmin = store.getters.hasAdminAccess(DEF_AUTHCODES.admon)
    //
    const stErrorCb = err => { notify(err.message, "error", 3000); }
    const deviceDataService = new RawDataService('device');

    const configData = new reactive(confObj);

    deviceDataService.getByKey('config').then(data => {
      Object.assign(configData, data)
    })


    const saveChanges = async () => {
      try{
        const confUpdateRes = await deviceDataService.update('config', configData);
        notify(confUpdateRes.message||"update sent to device", "success", 4000);
      }catch(error){ stErrorCb(error); }
    }

    const setDefaults = async () => {
      try{
        const confUpdateRes = await deviceDataService.remove('config');
        notify(confUpdateRes.message||"update sent to device", "success", 4000);
      }catch(error){ stErrorCb(error); }
    }

    const reload = () => { console.log('reload'); }

    return {
      isMyUserAdmin,
      configData,
      reload,
      saveChanges,
      setDefaults,
    }
  },
}
</script>

<style>
.third-group {
  background-color: rgba(205, 205, 205, 0.15);
  padding: 10px 10px 10px 0px;
}

</style>
